import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** The tick, used by `Checkbox` and a pressed `Chip`. */
export function TickGlyph({ className = 'tick' }) {
    return (_jsx("svg", { className: className, viewBox: "0 0 11 9", "aria-hidden": "true", focusable: "false", children: _jsx("path", { d: "M1 4.6 4 7.6 10 1.2", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "square" }) }));
}
/** The chevron. `left` is the rail's back link; `right` is a disclosure. */
export function ChevronGlyph({ className = 'tick', direction = 'right', }) {
    return (_jsx("svg", { className: className, viewBox: "0 0 8 10", "aria-hidden": "true", focusable: "false", style: {
            width: 8,
            height: 10,
            transform: direction === 'left' ? 'rotate(180deg)' : undefined,
        }, children: _jsx("path", { d: "M2 1 6 5 2 9", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "square" }) }));
}
/**
 * The wordmark's glyph — a cut page with its corner turned: the brand's
 * material and its signature motion in one mark (addendum §09).
 */
/** The remove control on a removable option chip. */
export function CrossGlyph({ className }) {
    return (_jsx("svg", { className: className, viewBox: "0 0 9 9", "aria-hidden": "true", focusable: "false", style: { width: 9, height: 9 }, children: _jsx("path", { d: "M1 1 8 8M8 1 1 8", fill: "none", stroke: "currentColor", strokeWidth: "1.6" }) }));
}
/** The "…" of a row menu. Horizontal, so it reads as "more", not "loading". */
export function DotsGlyph({ className }) {
    return (_jsxs("svg", { className: className, viewBox: "0 0 14 4", "aria-hidden": "true", focusable: "false", children: [_jsx("circle", { cx: "2", cy: "2", r: "1.6", fill: "currentColor" }), _jsx("circle", { cx: "7", cy: "2", r: "1.6", fill: "currentColor" }), _jsx("circle", { cx: "12", cy: "2", r: "1.6", fill: "currentColor" })] }));
}
/** Add — the axis editor's one growth affordance. */
export function PlusGlyph({ className }) {
    return (_jsx("svg", { className: className, viewBox: "0 0 10 10", "aria-hidden": "true", focusable: "false", style: { width: 10, height: 10 }, children: _jsx("path", { d: "M5 1v8M1 5h8", fill: "none", stroke: "currentColor", strokeWidth: "1.6" }) }));
}
//# sourceMappingURL=glyphs.js.map